import React from 'react';
import {
  Box,
  Typography,
  Avatar,
  ListItemIcon,
  ListItemText,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

const IntervenantFilter = ({ intervenants, value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 240 }}>
    <Select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      displayEmpty
      IconComponent={FilterListIcon}
      renderValue={(selected) => {
        if (selected === '') {
          return (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: '#64748B',
              }}
            >
              <FilterListIcon sx={{ fontSize: 18 }} />
              <span>Tous les praticiens et intervenants</span>
            </Box>
          );
        }
        const intervenant = intervenants.find((i) => i.id_user === selected);
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar
              sx={{
                width: 22,
                height: 22,
                fontSize: '0.7rem',
                bgcolor: '#3B82F6',
              }}
            >
              {intervenant?.prenom_user?.[0]}
            </Avatar>
            <Typography sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
              {intervenant?.prenom_user} {intervenant?.nom_user}
            </Typography>
          </Box>
        );
      }}
      sx={{
        bgcolor: 'white',
        borderRadius: '12px',
        transition: 'all 0.2s',
        border: '1px solid #E2E8F0',
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&:hover': {
          bgcolor: '#F8FAFC',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        },
        '&.Mui-focused': {
          boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.2)',
        },
        '& .MuiSelect-icon': {
          right: 12,
          color: '#94A3B8',
          fontSize: '1.2rem',
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: '12px',
            mt: 1,
            boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
            border: '1px solid #F1F5F9',
            maxHeight: 300,
          },
        },
      }}
    >
      <MenuItem
        value=""
        sx={{ color: '#64748B', fontStyle: 'italic', py: 1.5 }}
      >
        Aucun filtre (Tous)
      </MenuItem>

      {intervenants.map((i) => (
        <MenuItem
          key={i.id_user}
          value={i.id_user}
          sx={{
            py: 1,
            px: 2,
            mx: 0.5,
            borderRadius: '8px',
            '&.Mui-selected': { bgcolor: '#EFF6FF !important' },
            '&:hover': { bgcolor: '#F1F5F9' },
          }}
        >
          <ListItemIcon>
            <Avatar sx={{ width: 28, height: 28, fontSize: '0.8rem' }}>
              {i.prenom_user?.[0]}
              {i.nom_user?.[0]}
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary={`${i.prenom_user} ${i.nom_user}`}
            primaryTypographyProps={{ fontSize: '0.9rem', fontWeight: 500 }}
          />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default IntervenantFilter;
